import { LevelProgressDto } from '../../shared/types/LevelProgressDto';

export interface BreadcrumbTitle {
  title: string;
  subtitle?: string;
  titleType?: string;
  breadcrumb: string;
}

export function getBreadcrumbTitle(
  courseTitle: string,
  lessonNumber: number,
  levelName: string,
  unitName: string
): BreadcrumbTitle {
  const [title, subtitle, titleType] = getCourseTitleParts(courseTitle);
  const breadcrumb = subtitle
    ? getLessonBreadcrumb(subtitle, lessonNumber, levelName, unitName)
    : getReviewQuizBreadcrumb(title, levelName, unitName);

  return {
    title,
    subtitle,
    titleType,
    breadcrumb,
  };
}

function getCourseTitleParts(title: string) {
  return title.split('|').map((item) => item.trim());
}

function getLessonBreadcrumb(subtitle: string, lessonNumber: number, levelName: string, unitName: string) {
  const part = `PART ${subtitle.replace(/\D/g, '') || 0}`;
  const lessonSegment = lessonNumber ? `LESSON ${lessonNumber} > ` : '';
  const breadcrumbTitle = `${levelName} > ${unitName} > ${lessonSegment}${part}`;
  return breadcrumbTitle;
}

function getReviewQuizBreadcrumb(title: string, levelName: string, unitName: string) {
  const part = title.toLocaleUpperCase().replace(unitName, '').trim();
  const breadcrumbTitle = `${levelName} > ${unitName} > ${part}`;
  return breadcrumbTitle;
}



// WEBPACK FOOTER //
// ./ts/app/learning/lesson-page/lesson-breadcrumb-utils.ts